import {ISubmissionProps} from '../../resources/submission';

export const getIndicators = (submissions: ISubmissionProps[]) => {
    const values = {
        poorHealth: 0,
        healthConditions: 0,
    };

    submissions.forEach(submission => {
        if (['3', '4'].includes(submission.domanda10?.toString() ?? '')) {
            values.poorHealth++;
        } else if (['1', '2'].includes(submission.domanda10?.toString() ?? '')) {
            values.healthConditions++;
        }
    })

    return [
        Number((values.poorHealth / submissions.length * 100).toFixed(2)),
        Number((values.healthConditions / submissions.length * 100).toFixed(2)),
    ];
}